import { render, staticRenderFns } from "./TitleIntroduction.vue?vue&type=template&id=612d57b8&scoped=true"
import script from "./TitleIntroduction.vue?vue&type=script&lang=js"
export * from "./TitleIntroduction.vue?vue&type=script&lang=js"
import style0 from "./TitleIntroduction.vue?vue&type=style&index=0&id=612d57b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612d57b8",
  null
  
)

export default component.exports